export const O_CLIENT_APP = "OVACUS_WEB_UI";
export const AUTHORIZATION_HEADER_KEY = "Authorization";
export const ACTOR_ID_HEADER_KEY = "O-ACTOR-ID";
export const CLIENT_NAME_HEADER_KEY = "O-CLIENT-NAME";
export const CLIENT_NAME_HEADER_VALUE = "OVACUS_WEB_UI";
export const O_API_KEY = "fe4c97e9-1733-4f13-8ac9-c6e56ea0a98a";

const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || "https";

// Require REACT_APP_ENV to be explicitly set; fail if missing
const ENV = process.env.REACT_APP_ENV;
if (!ENV) {
  throw new Error(
    "REACT_APP_ENV environment variable is required. " +
      "Set it via .env.local (e.g., REACT_APP_ENV=dev) or Cloud Build substitution _ENV."
  );
}

const HOST_MAP = {
  prod: "api.oliveeb.com",
  production: "api.oliveeb.com",
  uat: "uat.oliveeb.com",
  staging: "uat.oliveeb.com",
  dev: "dev.oliveeb.com",
  development: "dev.oliveeb.com",
};

const DEFAULT_HOST = HOST_MAP[ENV] || HOST_MAP.dev;
export const API_HOST = process.env.REACT_APP_API_HOST || DEFAULT_HOST;
export const API_BASE_URL = `${API_PROTOCOL}://${API_HOST}`;

export const CORE_API_BASE_URL = `${API_BASE_URL}/api/v1`;
export const IDENTITY_SERVICE_BASE_URL = `${API_BASE_URL}/identity-service`;
export const OLITASK_SERVICE_BASE_URL = `${API_BASE_URL}/olitask-service`;
export const PAYMENT_SERVICE_BASE_URL = `${API_BASE_URL}/payment-service`;
export const PM_SERVICE_BASE_URL = `${API_BASE_URL}/pm-service`;
export const CHAT_SERVICE_BASE_URL = `${API_BASE_URL}/chat-service`;
export const PROFILE_SERVICE_BASE_URL = `${API_BASE_URL}/profile-service`;
export const OLREADIA_SERVICE_BASE_URL = `${API_BASE_URL}/olreadia-service`;
export const STORAGE_BASE_URL = `${API_BASE_URL}/storage-service`;
export const COMMUNICATION_SERVICE_BASE_URL = `${API_BASE_URL}/communication-service`;
export const NOTIFICATION_SERVICE_BASE_URL = `${API_BASE_URL}/notification-service`;
export const EMAIL_SERVICE_BASE_URL = `${API_BASE_URL}/email-service`;

// Mirrors `com.oliveeb.gateway.model.OliveebApp` (gateway-service).
// Backend serializes these enums as the lowercase, hyphenated strings via `@JsonValue`.
export const OLIVEEB_APP_VALUES = [
  // ===== Frontend Applications =====
  "olitask-mobile-ui",
  "olitask-web-ui",
  "ovacus-mobile-ui",
  "ovacus-web-ui",
  "oliveeb-admin-portal-web-ui",
  "oliveeb-postman-internal",

  // ===== Core Backend Services =====
  "olitask-main-service",
  "oliveeb-gateway-service",
  "oliveeb-identity-service",
  "oliveeb-profile-service",
  "oliveeb-payment-service",
  "oliveeb-storage-service",
  "oliveeb-notification-service",
  "oliveeb-chat-service",
  "oliveeb-communication-service",
  "oliveeb-email-service",
  "oliveeb-code-service",
  "oliveeb-cache-service",
  "oliveeb-social-service",
  "oliveeb-pm-service",
  "oliveeb-ai-service",
  "anonymous-service",
];

export const OLIVEEB_APP_OPTIONS = OLIVEEB_APP_VALUES.map((value) => ({
  value,
  label: value,
}));

export const CHARGE_ITEM_CODES = {
  OVACUS_APP_SUBSCRIPTION: "OVACUS_APP_SUBSCRIPTION",
  OVACUS_APP_SUBSCRIPTION_REFUND: "OVACUS_APP_SUBSCRIPTION_REFUND",
};

export const CHARGE_ITEM_LABELS = {
  [CHARGE_ITEM_CODES.OVACUS_APP_SUBSCRIPTION]: "Ovacus App Subscription",
  [CHARGE_ITEM_CODES.OVACUS_APP_SUBSCRIPTION_REFUND]: "Ovacus App Subscription Refund",
};

export const APP_LINKS = {
  ios: "https://appstoreconnect.apple.com/teams/767e23a7-ecf5-4a22-815e-5525630bddd7/apps/6753580996/testflight/ios",
  android: "https://play.google.com/apps/internaltest/4701619456935802876",
};

export const SMART_APP_LINK = APP_LINKS.both;

export const FEATURE_PROJECT_TEAM_MANAGEMENT = true;
